// Web <Type /> relies on base-styles defaults from CSS stylesheet
// so no additional default values are needed in here
//
// This file is merged into the default context value in TypographyContext.jsx
export default {};